import React, { useEffect, useState } from "react";
import { TablePagination, Typography } from "@material-ui/core";
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import AccordionCertificate from "./accordionCertificate";
import { getMaestras } from "../../actions/generation-contarct-action";
import { getemployees } from "../../actions/employee-action";
import SearchCertification from "./searchCertification";
import { getProfilePosition } from "../../actions/position-actions";
import _ from "lodash";
import { handleClickCloseRedirect } from "../../utils/functionsUtils";

const WorkCertificate = () => {
  const classes = styles();
  const [{ filterCertificateReducer }, dispatch] = useStateValue();
  const [maestras, setMaestras] = useState([]);
  const [charges, setCharges] = useState([]);

  const [data, setData] = useState({
    email: null,
    firstName: null,
    surname: null,
    documentType: null,
    document: null,
    status: null,
    initDate: null,
    endDate: null,
    chargeDenomination: null,
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestión de empleados",
      breadCrumbSubText: "Gestión de empleados",
      index: 42,
    });
  }, [dispatch]);

  useEffect(() => {
    const getListTeachers = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListTeachers();
  }, []);

  useEffect(() => {
    const getListCharges = async () => {
      const response = await getProfilePosition("ACTIVO");
      setCharges(
        _.sortBy(response?.data?.chargeList, [
          function (o) {
            return o.denomination;
          },
        ])
      );
    };
    getListCharges();
  }, []);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const returnMessage = (msj, type, action) => {
    setMessage({
      description: msj,
      textButtonSubmit: "ACEPTAR",
      handleClick: () => action(),
      oneButtons: true,
      type: type,
      open: true,
    });
  };

  const getRequest = async () => {
    const response = await getemployees(
      {
        firstName: data.firstName === "" ? null : data.firstName,
        surname: data.surname === "" ? null : data.surname,
        document: data.document === "" ? null : data.document,
        documentType: data.documentType === "" ? null : data.documentType,
        chargeId:
          data.chargeDenomination === "" ? null : data.chargeDenomination,
        status: data.status === "" ? null : data.status,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const resp = response?.data?.employeesPagePage;
      if (resp?.content.length > 0) {
        setPaginadorResponse({
          data: resp?.content,
          totalRows: resp?.totalElements,
          pageSize: resp?.size,
          pageNumber: resp?.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else if (response?.status === 401 || response === undefined) {
      const msj = "Su sesión ha expirado, ingrese de nuevo";
      returnMessage(msj, "WARNING", handleClickCloseRedirect);
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      const msj = response?.data?.detail
        ? response?.data?.detail
        : response?.data?.error;
      returnMessage(msj, "WARNING", handleClickClose);
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    getRequest();
  }, [paginadorRequest]);

  if (
    filterCertificateReducer &&
    filterCertificateReducer.isFilter &&
    data !== filterCertificateReducer.filter
  ) {
    const filter = filterCertificateReducer?.filter;
    data.email = filter?.email;
    data.firstName = filter?.firstName;
    data.surname = filter?.surname;
    data.documentType = filter?.documentType;
    data.document = filter?.document;
    data.status = filter?.status;
    data.chargeDenomination = filter?.chargeDenomination;
    data.initDate = filter?.initDate;
    data.endDate = filter?.endDate;
    paginadorRequest.page = 0;
    dispatch({
      type: "SET_FILTER_CERTIFICATE",
      isFilter: false,
    });
    getRequest();
  }

  const validPerSearchCertification = () => {
    return (
      <>
        <SearchCertification maestras={maestras} charges={charges} />
      </>
    );
  };

  return (
    <div>
      {validPerSearchCertification()}
      {paginadorResponse?.data.length > 0
        ? paginadorResponse?.data.map((data) => (
            <AccordionCertificate
              data={data}
              message={message}
              setMessage={setMessage}
              maestras={maestras}
            />
          ))
        : null}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}
      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        threeButtons={message.threeButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default WorkCertificate;
